import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const newTravelPolicyFormSlice = createSlice({
    name: 'newTravelPolicyFormData',
    initialState,
    reducers: {
        setTravelPolicyFormData: (state, action) => {
            const { key, data } = action.payload;
            state[key] = data;
        },
        removeTravelPolicyFormData: (state, action) => {
            const key = action.payload;
            delete state[key];
        },
        resetTravelPolicyFormData: (state) => {
            return initialState;
        },
    },
});

export const {
    setTravelPolicyFormData,
    removeTravelPolicyFormData,
    resetTravelPolicyFormData,
} = newTravelPolicyFormSlice.actions;

export const selectTravelPolicyFormData = (state) => state.newTravelPolicyFormData;

export default newTravelPolicyFormSlice.reducer;
